/* eslint-disable react-hooks/rules-of-hooks */
import { GetState, SetState } from 'zustand';
import {
  COMPLETED,
  GOAL_M_COMPLETED,
  GOAL_M_REMOVED,
  GOAL_M_UPDATED,
  M_Error,
  M_Success,
  S_Goals,
} from '../../common/Types';
import {
  removeByKey,
  removeListByParentKey,
  updateByKey,
} from '../../firebase/refActions';
import { goalRef, taskRef } from '../../firebase/refs';
import { GoalI } from '../../interfaces/GoalInterface';
import { addGoal, getAllGoals } from '../actions/goalActions';
import { AppStatesI, GoalStatesI } from '../interfaces/storeStatesInterface';

const initState = {
  allGoals: [],
  plannedGoals: [],
  progressGoals: [],
  completedGoals: [],

  goal: null,
};
export const createGoalStates = (
  setState: SetState<AppStatesI>,
  _get: GetState<AppStatesI>
): GoalStatesI => {
  return {
    ...initState,
    fetchAllGoals: async () => await getAllGoals(setState),
    clearGoalStates: () => {
      _get().clearStateMessages(S_Goals);
      setState({ ...initState });
    },

    addGoal: async (_goal: GoalI) => addGoal(setState, _get, _goal),
    setGoal: async (_goal: GoalI | null) => setState({ goal: _goal }),
    updateGoal: async (_goal: GoalI) => {
      try {
        if (!_goal.key) throw new Error('Goal key missing');

        _get().setLoading(true);
        updateByKey(goalRef, _goal.key, _goal, () => {
          _get().addMessage({
            type: M_Success,
            content: GOAL_M_UPDATED,
            stateName: S_Goals,
          });
        });

        _get().setLoading(false);
      } catch (error) {
        _get().addMessage({
          type: M_Error,
          content: error,
          stateName: S_Goals,
        });
        _get().setLoading(false);
      }
    },
    updateGoalStatus: async (_goal: GoalI) => {
      try {
        if (!_goal.key) throw new Error('Goal key missing');

        _get().setLoading(true);
        updateByKey(goalRef, _goal.key, _goal, () => {
          _get().setLoading(false);
        });
      } catch (error) {
        _get().addMessage({
          type: M_Error,
          content: error,
          stateName: S_Goals,
        });
        _get().setLoading(false);
      }
    },
    completedGoal: async (_goal: GoalI) => {
      try {
        if (!_goal.key) throw new Error('Goal key missing');

        _get().setLoading(true);
        updateByKey(
          goalRef,
          _goal.key,
          { ..._goal, goalStatus: COMPLETED },
          () => {
            _get().addMessage({
              type: M_Success,
              content: GOAL_M_COMPLETED,
              stateName: S_Goals,
            });
          }
        );

        _get().setLoading(false);
      } catch (error) {
        _get().addMessage({
          type: M_Error,
          content: error,
          stateName: S_Goals,
        });
        _get().setLoading(false);
      }
    },
    removeGoal: async (_goal: GoalI) => {
      try {
        if (!_goal.key) throw new Error('Goal key missing');
        _get().setLoading(true);
        removeListByParentKey(taskRef, _goal.key, 'goal_key', () => {
          removeByKey(goalRef, _goal.key, () => {
            _get().addMessage({
              type: M_Success,
              content: GOAL_M_REMOVED,
              stateName: S_Goals,
            });
          });
        });
        _get().setLoading(false);
      } catch (error) {
        _get().addMessage({
          type: M_Error,
          content: error,
          stateName: S_Goals,
        });
        _get().setLoading(false);
      }
    },
  };
};
